export const Environment = Object.freeze({
  DEVELOPMENT: 'development',
  TEST: 'testing',
  PRODUCTION: 'production',
  UAT: 'uat'
})
